import towheed from "../assets/towheed.png";
import jadid from "../assets/nasrullah.jpg";
import zahid from "../assets/zahid.jpg";
import mohsin from "../assets/mohsin.png";

const author = [
    {
        id: 1,
        name: "Md Towheed",
        img: towheed,
    },
    {
        id: 2,
        name: "Nasrullah Al Jadid",
        img: jadid,
    },
    {
        id: 3,
        name: "Zahid hasan",
        img: zahid,
    },
    {
        id: 4,
        name: "Mohsin Alim Akash",
        img: mohsin,
    },
];

export default author;
